import { render, staticRenderFns } from "./StandardColor.vue?vue&type=template&id=c34ee460&scoped=true&"
import script from "./StandardColor.vue?vue&type=script&lang=js&"
export * from "./StandardColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34ee460",
  null
  
)

export default component.exports